// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"d89023a2","348":"ebd034bf","571":"dde3c269","924":"eca24ee8"}[chunkId] + ".chunk.js";
};